import { Url } from '../shared/Url';
import Post from '../shared/Post';
import { cookieData } from '../funciones/ConsultaUser';
import { requerido } from './Validaciones'

export const ConsultaEventos = (date, respuesta) => {
    let Content = {
        date: date
    }
    
    Post(`${Url}consultEventos`, Content, (resp) => {

        let data1 = JSON.parse(resp);
        let data = data1[0];
        let contenido= [];

        for (let i in data) {
            contenido.push(
                {
                    id: data[i][0].id,
                    codigo_color: data[i][0].codigo_color,
                    event_name: data[i][0].event_name
                }
            )
        }
        respuesta(contenido)
    });
}

export const ConsultaRangoEventos = (rango, respuesta) => {
    let Content = {
        rango: rango
    }

    Post(`${Url}consultRangoEventos`, Content, (resp) => {
        let data = JSON.parse(resp);
        respuesta(data[0])
    });
}

export const ConsultaColores = (respuesta) => {

    Post(`${Url}consultColores`, "", (resp) => {
        let data = JSON.parse(resp);

        let Contenido = [];

        for (let i in data[0]){
            Contenido.push(
                { value: data[0][i].id, label: data[0][i].codigo_color }
            )
        }

        respuesta(Contenido)
    });
}

export const ConsultEventInd = (id, respuesta) => {
    let Content = {
        id: id
    }

    Post(`${Url}consultEventoInd`, Content, (resp) => {
        let data = JSON.parse(resp);
        respuesta(data[0][0])
    });
}

export const UpdEvent = (id, datos, respuesta) => {
    let errores = 0;
    let nameErr = [];
    let states = [];

    let mensaje = [{
        status: "error",
        mensaje: "No se pudo editar la información. Revisa los errores encontrados para continuar"
    }];

    /* Validaciones */
    requerido(errores, datos.fechaIn, "", "", "", "Selecciona la fecha de inicio del evento", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, datos.fechaOut, "", "", "", "Selecciona la fecha de culminación del evento", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, datos.dEvent, "", "", "", "Debes indicar la Descripción del Evento", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, datos.quien.value, "", "", "", "Debes indicar con quien deseas compartir el evento", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, datos.quien.value, "", "", "", "Selecciona un color para el evento", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    if (errores === 0){
        cookieData((cookie) => {
            let Content = {
                uId: cookie[1],
                FechaIn: datos.fechaIn,
                FechaOut: datos.fechaOut,
                Evento: datos.dEvent,
                Color: datos.valorColor.value,
                Status: datos.quien.value,
                Id: id
            }
    
            Post(`${Url}UpdEventDir`, Content, (resp) => {
                mensaje = [{
                    status: "info",
                    mensaje: "Se ha actualizado correctamente este evento"
                }];
                respuesta([states, mensaje, errores, nameErr])
            });
        });
    }else{
        respuesta([states, mensaje, errores, nameErr])
    }
}

export const ConsultaEventEx = (datos, respuesta) => {
    let errores = 0;
    let nameErr = [];
    let states = [];

    let mensaje = [{
        status: "error",
        mensaje: "No se pudo guardar la información. Revisa los errores encontrados para continuar"
    }];

    /* Validaciones */
    requerido(errores, datos.fechaIn, "", "", "", "Selecciona la fecha de inicio del evento", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, datos.fechaOut, "", "", "", "Selecciona la fecha de culminación del evento", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, datos.dEvent, "", "", "", "Debes indicar la Descripción del Evento", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, datos.quien.value, "", "", "", "Debes indicar con quien deseas compartir el evento", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, datos.quien.value, "", "", "", "Selecciona un color para el evento", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    if (errores === 0){
        let Content = {
            rango: datos.contenido
        }

        Post(`${Url}consultRangoEventos`, Content, (resp) => {
            let data = JSON.parse(resp);
            let fechas = [];

            for (let i in data[0]){
                if (data[0][i].Coincidencias.length > 0) fechas.push(data[0][i])
            }
            
            if (fechas.length > 0){
                states = "fechas_duplicadas";
                errores = fechas.length
            }
            
            respuesta([states, errores, fechas])
        });

    }else{
        respuesta([states, mensaje, errores, nameErr])
    }
}

export const AddNewEvento = (datos, respuesta) => {
    let errores = 0;
    let nameErr = [];
    let states = [];

    let mensaje = [{
        status: "error",
        mensaje: "No se pudo guardar la información. Revisa los errores encontrados para continuar"
    }];

    /* Validaciones */
    requerido(errores, datos.fechaIn, "", "", "", "Selecciona la fecha de inicio del evento", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, datos.fechaOut, "", "", "", "Selecciona la fecha de culminación del evento", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, datos.dEvent, "", "", "", "Debes indicar la Descripción del Evento", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, datos.quien.value, "", "", "", "Debes indicar con quien deseas compartir el evento", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, datos.quien.value, "", "", "", "Selecciona un color para el evento", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    if (errores === 0){
        cookieData((cookie) => {
            let Content = {
                uId: cookie[1],
                FechaIn: datos.fechaIn,
                FechaOut: datos.fechaOut,
                Evento: datos.dEvent,
                Color: datos.valorColor.value,
                Status: datos.quien.value
            }
    
            Post(`${Url}addEventDir`, Content, (resp) => {
                mensaje = [{
                    status: "info",
                    mensaje: "Se ha registrado correctamente este evento"
                }];
                respuesta([states, mensaje, errores, nameErr])
            });
        });
    }else{
        respuesta([states, mensaje, errores, nameErr])
    }
}

export const DelEvento = (id, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            id: id
        }

        Post(`${Url}delEventDir`, Content, (resp) => {
            respuesta (resp)
        });
    });
    
}


// WEBPACK FOOTER //
// ./src/funciones/AgendaFunction.jsx